<template>
    <div>
        <div class="content">
            <div @click="clickHandler"
                class="filterbutton">
                Filtros
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'filterbutton',
    methods: {
        clickHandler() {
            this.$store.dispatch('turnFilterUI', true)
        }
    },
    computed: {
        blurMode() {
            return this.$store.state.turnFilterUI
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/vars';
.content,
.filterbutton {
    height: 3.2rem;
}

.filterbutton {
    text-transform: uppercase;
    background: #F5F5F5;
    color: #979797;
    cursor: pointer;
    font-size: 1.5rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius:50px;
    &::selection {
        background: transparent;
        color: inherit;
    }
    @media (min-width: $min-md) {
        display: none;
    }
}
</style>
